import React from "react"

import { IntersectionObserver } from "@atoms/IntersectionObserver/IntersectionObserver"
import VideoJWPlayer from "@atoms/VideoJWPlayer/VideoJWPlayer"
import VideoReactPlayer from "@atoms/VideoReactPlayer/VideoReactPlayer"

import styles from "./VideoAdvanced.module.scss"

const VideoAdvanced = ({
  variant,
  heading,
  embed,
  jwplayer,
  posterImage,
  caption,
  background,
  jwPlayerIDs,
  autoplayWhenVisible = false,
}) => {
  let jwPlayerIDsObject = {}

  if (jwPlayerIDs && Array.isArray(jwPlayerIDs)) {
    jwPlayerIDs.forEach((string) => {
      let array = string?.split("|")
      if (array.length === 2) {
        jwPlayerIDsObject[array[0]] = array[1]
      }
    })
  }

  return (
    <IntersectionObserver reset={true}>
      <section
        className={`${styles.element} ${
          heading ? styles.hasHeading : styles.noHeading
        } ${
          background ? styles[background] : styles.pink
        } section-break-out section-break-out-no-margins-mobile large-area-element`}
      >
        <div className="container">
          {heading && <h2 className={styles.heading}>{heading}</h2>}
          {!jwplayer && (
            <VideoReactPlayer
              type={variant}
              url={embed}
              posterImage={posterImage}
              autoplayWhenVisible={autoplayWhenVisible}
            />
          )}
          {jwplayer && jwPlayerIDsObject && jwPlayerIDsObject[jwplayer] && (
            <VideoJWPlayer
              id={jwPlayerIDsObject[jwplayer]}
              autoplayWhenVisible={autoplayWhenVisible}
            />
          )}
          {caption && <p className={styles.caption}>{caption}</p>}
        </div>
      </section>
    </IntersectionObserver>
  )
}

export default VideoAdvanced
